import coerceToRecord from '../helpers/coerceToRecord';
import eventMatchesToolNames from '../helpers/eventMatchesToolNames';
import getStringValue from '../helpers/getStringValue';
import type {
    BuildRefetchSkillOnMutationSubscriptionParams,
    ChatEffectSubscription,
} from '../types';

const SKILL_MUTATION_TOOL_NAMES = [
    'update_skill',
    'update_skill_resource',
    'add_skill_resource',
    'remove_skill_resource',
    'publish_skill',
    'deprecate_skill',
    'promote_skill',
    'restore_skill_version',
    'restore_skill_revision',
    'restore_skill_resource_revision',
];

const SKILL_LIFECYCLE_TOOL_NAMES = [
    'publish_skill',
    'deprecate_skill',
    'promote_skill',
    'restore_skill_version',
];

const buildRefetchSkillOnMutationSubscription = (
    _params: BuildRefetchSkillOnMutationSubscriptionParams
): ChatEffectSubscription => {
    return {
        id: 'refetch-skill-on-mutation',
        routePattern: '*',
        eventType: 'TOOL_CALL_RESULT',
        filter: ({ event }) => {
            if (!eventMatchesToolNames({ event, toolNames: SKILL_MUTATION_TOOL_NAMES })) {
                return false;
            }

            const args = coerceToRecord({ value: event.args });
            const result = coerceToRecord({ value: event.result });
            const resultSkill = coerceToRecord({ value: result.skill });
            const skillIdFromArgs = getStringValue({ value: args.skillId });
            const skillIdFromResult = getStringValue({ value: resultSkill.id });
            const skillId = skillIdFromArgs || skillIdFromResult;
            return skillId !== '';
        },
        action: ({ event, queryClient }) => {
            const args = coerceToRecord({ value: event.args });
            const result = coerceToRecord({ value: event.result });
            const resultSkill = coerceToRecord({ value: result.skill });
            const skillIdFromArgs = getStringValue({ value: args.skillId });
            const skillIdFromResult = getStringValue({ value: resultSkill.id });
            const skillId = skillIdFromArgs || skillIdFromResult;

            if (!skillId) {
                return;
            }

            queryClient.invalidateQueries(['skill', skillId]);
            queryClient.invalidateQueries(['skill-resources', skillId]);
            queryClient.invalidateQueries(['skill-resource', skillId]);

            if (eventMatchesToolNames({ event, toolNames: SKILL_LIFECYCLE_TOOL_NAMES })) {
                queryClient.invalidateQueries(['skill-published-versions', skillId]);
                queryClient.invalidateQueries(['skills']);
                queryClient.invalidateQueries(['skills-search']);
            }
        },
    };
};

export default buildRefetchSkillOnMutationSubscription;
